import { TabsProps } from './Tabs.types';
import { TabsSt as MUITabs } from './Tabs.css';

export default function Tabs(props: TabsProps) {
  return <MUITabs {...props} />;
}
